//
//
//
//
//
//
//
//
//
//

import loadingView from './loading-view';
import errorView from './error-view';
import emptyView from './empty-view';
import nullData from 'components/NullData';
export default {
  name: 'data-controller',
  components: {loadingView, errorView, nullData, emptyView},
  props: {
    data: {
      type: Object,
    },
    emptyData: {
      type: Object
    }
  },
  mounted() {
  },
  methods: {
    click() {
      this.$emit('click');
    }
  },
  data() {
    return {};
  }
};



// WEBPACK FOOTER //
// ./src/components/app/dataController.vue